module.exports = __webpack_public_path__ + "static/media/bg-2-features.94e40c84.svg";